export class IndexGridViewItem {
    id?: string;
    value?: number;
    year?: number;
    coef?: number;
    modifiedDate?: Date;
    userName?: string;
    constructor(indexGridViewItem?: IndexGridViewItem) {
        this.id = indexGridViewItem?.id;
        this.value = indexGridViewItem?.value;
        this.year = indexGridViewItem?.year;
        this.coef = indexGridViewItem?.coef;
        this.modifiedDate = indexGridViewItem?.modifiedDate;
        this.userName = indexGridViewItem?.userName;
    }
}
